const $ = jQuery.noConflict();

class Slider {
  constructor(selector, args = {}) {
    this.selector = selector;
    this.args = args;
  }

  getDefaultSlickSettings() {
    return {
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      speed: 600,
    };
  }

  /**
   * Override our default slick settings with args provided to the class.
   */
  getSlickSettings() {
    return Object.assign({}, this.getDefaultSlickSettings(), this.args);
  }

  init() {
    let settings = this.getSlickSettings();

    $(this.selector).slick(settings);
  }
}

const SimpleSlider = new Slider(".gallery-slider__slider");
const TestimonialSlider = new Slider(".testimonial-slider");
const FluidSlider = new Slider(".gallery-slider__slider-fluid", {
  centerMode: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1290,
      settings: {
        centerMode: false,
        variableWidth: false,
      },
    },
  ],
});
const MainSlider = new Slider(".main-slider", {
  arrows: false,
  autoplay: true,
  autoplaySpeed: 6000,
  cssEase: "linear",
  dots: true,
  fade: true,
  speed: 600,
  pauseOnHover: true,
});
const AboutSlider = new Slider(".about-slider", {
  arrows: false,
  dots: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: false,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
});
const MeetSlider = new Slider(".meet-slider", {
  accessibility: false,
  autoplay: true,
  autoplaySpeed: 9000,
  cssEase: "linear",
  dots: true,
  draggable: false,
  fade: true,
  pauseOnFocus: false,
  pauseOnHover: false,
  pauseOnDotsHover: false,
});
export {
  SimpleSlider,
  TestimonialSlider,
  FluidSlider,
  MainSlider,
  AboutSlider,
  MeetSlider,
};
